import { Container, Grid } from '@material-ui/core';

import { NAVIGATION_SECTION_IDS } from 'Constants/NavigationConstants';
import useLocalized from 'CustomHooks/useLocalized';
import ImagePresenter from 'UI/Components/ImagePresenter/ImagePresenter';
import {
  selcoBuilders,
  lords,
  raven,
  surreySteel,
  pbmBuilders,
  allenConcrete,
  maTrans,
} from 'UI/Screens/Main/Sections/Partners/Assets';
import { useGetPartnerContent } from "../../../../../Data/ApiHooks/UseContentHook";
import {useEffect} from "react";

const PARTNER_LIST = [
  {
    id: 'selcoBuilders',
    logo: selcoBuilders,
  },
  {
    id: 'lords',
    logo: lords,
  },
  {
    id: 'raven',
    logo: raven,
  },
  {
    id: 'surreySteel',
    logo: surreySteel,
  },
  {
    id: 'pbmBuilders',
    logo: pbmBuilders,
  },
  {
    id: 'allenConcrete',
    logo: allenConcrete,
  },
  {
    id: 'maTrans',
    logo: maTrans,
  },
];

const Partners = () => {

  const { data } = useGetPartnerContent();

  return (
    <div id={NAVIGATION_SECTION_IDS.partners} className="partners-section">
      <div className="partners-section__title">
        {useLocalized('partners_title')}
      </div>
      <Container className="partners-section__list">

        {/* Inline style is needed to correct a known MUI Grid bug causing vertical scroll */}
        <Grid container spacing={8} style={{ margin: 0, width: '100%' }}>
          {data?.map(({
            id,
            image,
            tags
          }) => (
            <Grid
              item
              key={id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="partners-section__list--element"
            >
              { tags ?
                (
                  <a href={tags} target="_blank" rel="noreferrer">
                    <ImagePresenter
                        containerClass="partners-section__list--element"
                        imageClass="partners-section__list--element--image"
                        src={image}
                    />
                  </a>
                ) : (
                  <ImagePresenter
                      containerClass="partners-section__list--element"
                      imageClass="partners-section__list--element--image"
                      src={image}
                  />
                )
              }
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  )
}

export default Partners;
